import type { StringMap } from 'corgi-types';

import type { ScaleAliasPrefix } from '../enums/ScaleAlias';

const removePixelUnit = <T>(value: T) => {
  // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
  return typeof value === 'string' ? value.replace(/px/, '') : `${value}`;
};

export const generateScaleAliases = <T>(prefix: ScaleAliasPrefix, property: T[], extended: T[]) => {
  const values = [...property, ...extended];

  values.forEach(value => {
    values[`${prefix}${removePixelUnit<T>(value)}`] = value;
  });

  return values as unknown as StringMap<T>;
};
